module.exports = __webpack_public_path__ + "static/img/top-bg.7e30c34d.png";